"use client"

import { cn } from "@/tiptap/lib/tiptap-utils"

function Input({
  className,
  type,
  ...props
}) {
  return (
    <input
      type={type}
      data-slot="tiptap-input"
      className={cn("tiptap-input", className)}
      {...props} />
  );
}

export { Input }
